import { useCancelDashboardOrderMutation } from '../../../../api'
import { type MutationResponse, useApolloMutationWrapper } from '../../../api'
import {
  type CancelDashboardOrderResponse,
  type CancelDashboardOrderRequestParams,
  type CancelDashboardOrderMeshResponse,
} from './types'

function mapResponse(data: CancelDashboardOrderMeshResponse): CancelDashboardOrderResponse {
  const payload =
    data.instacart_enterprise_frigate_fulfillment_v1_DashboardOrderService_CancelDashboardOrder

  if (payload?.operation?.error) {
    return {
      name: payload?.operation?.name ?? '',
      isDone: payload?.operation?.isDone ?? false,
      error: {
        typedErrors:
          payload?.operation?.error?.typedErrors?.map(error => ({
            errorType: error?.errorType ?? 'UNKNOWN_ERROR',
          })) ?? [],
      },
    }
  }

  return {
    name: payload?.operation?.name ?? '',
    isDone: payload?.operation?.isDone ?? false,
    value: {
      deliveryReference: payload?.operation?.value?.deliveryReference ?? '',
    },
  }
}

export const useCancelDashboardOrder = (): MutationResponse<
  CancelDashboardOrderResponse,
  CancelDashboardOrderRequestParams
> => {
  const mutationTuple = useCancelDashboardOrderMutation({
    variables: undefined,
    fetchPolicy: 'network-only',
  })

  return useApolloMutationWrapper({ mutationTuple, mapResponse })
}
